export default "__VITE_ASSET__DeTtsnBk__"